import moment from 'moment'
import {useEffect, useState} from 'react'
import {Button, Form, Modal, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {getBankList} from 'src/api/modules/master-data/master_2'

interface PropsInterface {
  data: Payload
  showModal: boolean
  options: OptionData
  isLoading: boolean
  closeModal: () => void
  edit: (data: Payload) => void
}

interface Payload {
  so_number: string
  sap_number: string
  dp_req_sap: string
  billing_number_sap: string
  clearing_doc_1: string
  clearing_doc_2: string
  bank_id: string
  currency?: string
  sector_id?: string
  billing_date: string
  send_to_sap: boolean
  processing_type: string
  flag?: string
}

interface OptionData {
  processing_types: any[]
}

export const EditModal = (props: PropsInterface) => {
  const {data, options, showModal, isLoading, closeModal, edit} = props
  const {t} = useTranslation()

  // form
  const [sapNumber, setSapNumber] = useState<string>('')
  const [DPReqNumber, setDPReqNumber] = useState<string>('')
  const [billingNumber, setBillingNumber] = useState<string>('')
  const [clearingDoc1, setClearingDoc1] = useState<string>('')
  const [clearingDoc2, setClearingDoc2] = useState<string>('')
  const [currency, setCurrency] = useState<string>('')
  const [bankId, setBankId] = useState<string>('')
  const [billingDate, setBillingDate] = useState<any>('')
  const [isSendToSAP, setIsSendToSAP] = useState<boolean>(false)
  const [processingType, setProcessingType] = useState<string>('')
  const [noTransaction, setNotTransaction] = useState<string>('')

  const [bankList, setBankList] = useState<any>([])
  const getCurrency = (sector: any) => {
    if (!sector) return ''
    if(sector == 3) return 'USD'
    return 'IDR'
  }

  useEffect(() => {
    setNotTransaction(data?.so_number)
    setSapNumber(data?.sap_number)
    setDPReqNumber(data?.dp_req_sap)
    setBillingNumber(data?.billing_number_sap)
    setClearingDoc1(data?.clearing_doc_1)
    setClearingDoc2(data?.clearing_doc_2)
    setBillingDate(data?.billing_date ? moment(data?.billing_date).format('YYYY-MM-DD') : '')
    setBankId(data?.bank_id)
    setCurrency(getCurrency(data?.sector_id))
    setIsSendToSAP(false)
    setProcessingType(data?.flag || '')
    setBank()
  }, [data])

  useEffect(() => {
    if (processingType == '1') {
      setSapNumber('')
      setDPReqNumber('')
      setBillingNumber('')
      setClearingDoc1('')
      setClearingDoc2('')
    } else if (processingType == '2') {
      setClearingDoc1('')
      setClearingDoc2('')
    }
  }, [processingType])

  const setBank = async () => {
    await getBankList().then((res: any) => setBankList(res.data?.data))
  }

  const handleEdit = () => {
    edit({
      so_number: data?.so_number,
      sap_number: sapNumber,
      dp_req_sap: DPReqNumber,
      billing_number_sap: billingNumber,
      clearing_doc_1: clearingDoc1,
      clearing_doc_2: clearingDoc2,
      bank_id: bankId,
      currency: currency,
      billing_date: billingDate,
      send_to_sap: isSendToSAP,
      processing_type: processingType
    })
  }

  const resetForm = () => {
    setSapNumber('')
    setDPReqNumber('')
    setBillingNumber('')
    setClearingDoc1('')
    setClearingDoc2('')
    setBillingDate('')
    setBankId('')
    setCurrency('')
    setIsSendToSAP(false)
    setProcessingType('')

    closeModal()
  }

  return (
    <Modal
      show={showModal}
      onHide={resetForm}
      backdrop='static'
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t('Edit')} {t('Log Sales Order')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Form.Group className='mb-5'>
          <Form.Label>{t('No Transaction')}</Form.Label>
          <Form.Control
            disabled
            size='sm'
            id='sap_number'
            placeholder={t('No Transaction')}
            value={`13`+noTransaction}
          />
        </Form.Group>

        <Form.Group className='mb-5'>
          <Form.Label>{t('No Sales Order')}</Form.Label>
          <Form.Control
            size='sm'
            id='sap_number'
            placeholder={t('No Sales Order')}
            value={sapNumber}
            onChange={(e: any) => setSapNumber(e.target.value)}
          />
        </Form.Group>

        <Form.Group className='mb-5'>
          <Form.Label>{t('No DP Req')}</Form.Label>
          <Form.Control
            size='sm'
            id='no_dp_req'
            placeholder={t('No DP Req')}
            value={DPReqNumber}
            onChange={(e: any) => setDPReqNumber(e.target.value)}
          />
        </Form.Group>

        <Form.Group className='mb-5'>
          <Form.Label>{t('No Billing DP')}</Form.Label>
          <Form.Control
            size='sm'
            id='no_billling_dp'
            placeholder={t('No Billing DP')}
            value={billingNumber}
            onChange={(e: any) => setBillingNumber(e.target.value)}
          />
        </Form.Group>

        <div hidden={(isSendToSAP && processingType != '3')}>
          <Form.Group className='mb-5'>
            <Form.Label>{t('Clearing Doc 1')}</Form.Label>
            <Form.Control
              size='sm'
              id='no_clearing'
              placeholder={t('Clearing Doc 1')}
              value={clearingDoc1}
              onChange={(e: any) => setClearingDoc1(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5'>
            <Form.Label>{t('Clearing Doc 2')}</Form.Label>
            <Form.Control
              size='sm'
              id='no_clearing'
              placeholder={t('Clearing Doc 2')}
              value={clearingDoc2}
              onChange={(e: any) => setClearingDoc2(e.target.value)}
            />
          </Form.Group>
        </div>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('mataUang')}</Form.Label>
          <Form.Select
            size='sm'
            aria-label='Default select example'
            onChange={(e: any) => setCurrency(e.target.value)}
          >
            <option value="">{t('mataUang')}</option>
            {['IDR', 'USD'].map((item: any) => {
              return (
                item == currency ? (
                    <option key={item} value={item} selected>
                        {item}
                    </option>
                ) : (
                    <option key={item} value={item}>
                        {item}
                    </option>
                )
              )
            })}
          </Form.Select>
        </Form.Group>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('Bank Payment')}</Form.Label>
          <Form.Select
            size='sm'
            aria-label='Default select example'
            onChange={(e: any) => setBankId(e.target.value)}
          >
            <option value="">{t('Bank Payment')}</option>
            {bankList.map((item: any) => {
              return (
                item.id == bankId ? (
                    <option key={item.id} value={item.id} selected>
                        {item.name}
                    </option>
                ) : (
                    <option key={item.id} value={item.id}>
                        {item.name}
                    </option>
                )
              )
            })}
          </Form.Select>
        </Form.Group>

        <Form.Group className='mb-5'>
          <Form.Label>{t('Tanggal-pembayaran')}</Form.Label>
          <Form.Control
            size='sm'
            id='billing_date'
            type='date'
            placeholder={t('Tanggal-pembayaran')}
            value={billingDate}
            onChange={(e: any) => setBillingDate(e.target.value)}
          />
        </Form.Group>

        <Form.Group className='mb-5'>
          <Form.Check
            style={{cursor: 'pointer', fontWeight: '500'}}
            type="checkbox"
            id="custom-switch"
            label={t('Send to SAP ?')}
            checked={isSendToSAP}
            onChange={(e: any) => setIsSendToSAP(e.target.checked)}
          />
        </Form.Group>

        {isSendToSAP && (
          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('Processing Type')}</Form.Label>
            <Form.Select
              size='sm'
              defaultValue={processingType}
              aria-label='Default select example'
              onChange={(e: any) => setProcessingType(e.target.value)}
            >
              <option value="">{t('Processing Type')}</option>
              {options.processing_types?.map((item: any) => {
                return (
                  item?.flag == processingType ? (
                      <option key={item?.flag} value={item?.flag} selected>
                          {item?.flag} - {item?.desc}
                      </option>
                  ) : (
                      <option key={item?.flag} value={item?.flag}>
                          {item?.flag} - {item?.desc}
                      </option>
                  )
                )
              })}
            </Form.Select>
          </Form.Group>
        )}

      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex justify-content-end'>
          <Button variant='light' className='me-2' onClick={() => closeModal()}>
              {t('Cancel')}
          </Button>
          <Button variant='primary' onClick={handleEdit} disabled={isLoading}>
            {isLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              <>{t('Edit')}</>
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
